import React from 'react';

export default function IconNotFound({ className }: { className?: string }) {
  return (
    <svg className={className} width="123" height="120" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M83.5 110.07c10.217 0 18.5-8.282 18.5-18.5 0-10.217-8.283-18.5-18.5-18.5S65 81.353 65 91.57c0 10.218 8.283 18.5 18.5 18.5z"
        fill="#E8E8E8"
      />
      <path
        clipRule="evenodd"
        d="M10 77.07a4 4 0 100-8 4 4 0 000 8z"
        stroke="#E8E8E8"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.464 43.535a1 1 0 000 1.414l2.122 2.121-2.122 2.122a1 1 0 001.415 1.414L115 48.484l2.121 2.122a1 1 0 001.415-1.414l-2.122-2.122 2.122-2.121a1 1 0 00-1.415-1.414L115 45.656l-2.121-2.121a1.001 1.001 0 00-1.415 0zm-91.999-25a1 1 0 000 1.414l2.12 2.121-2.12 2.122a1 1 0 001.414 1.414L23 23.484l2.121 2.122a1 1 0 101.415-1.414l-2.122-2.122 2.122-2.121a1 1 0 00-1.415-1.414L23 20.656l-2.121-2.121a1 1 0 00-1.415 0z"
        fill="#E8E8E8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51 39.07v-18a1 1 0 011-1h38a3 3 0 013 3v44.504a24.025 24.025 0 00-2-1.293v-43.21a1 1 0 00-1-1H53v17a5 5 0 01-5 5H30v55.999a1 1 0 001 1h28.504c.5.696 1.037 1.363 1.607 2H31a3 3 0 01-3-3v-57a1 1 0 011-1h19a3 3 0 003-3z"
        fill="#BDBDBD"
      />
      <path d="M52 21.07l-23 22" stroke="#BDBDBD" strokeWidth="2" />
      <rect x="39" y="57.07" width="42" height="2" rx="1" fill="#BDBDBD" />
      <rect x="39" y="65.07" width="22" height="2" rx="1" fill="#BDBDBD" />
      <rect x="39" y="73.07" width="15" height="2" rx="1" fill="#BDBDBD" />
      <path
        clipRule="evenodd"
        d="M91.511 100.492c7.271-6.78 7.669-18.17.889-25.44-6.78-7.27-18.17-7.668-25.44-.889-7.27 6.78-7.669 18.17-.889 25.44 6.78 7.271 18.17 7.669 25.44.889z"
        stroke="#BDBDBD"
        strokeWidth="2"
      />
      <rect
        x="70.515"
        y="80"
        width="2"
        height="22"
        rx="1"
        transform="rotate(-45 70.515 80)"
        fill="#BDBDBD"
      />
      <rect
        x="86.071"
        y="78.586"
        width="2"
        height="22"
        rx="1"
        transform="rotate(45 86.071 78.586)"
        fill="#BDBDBD"
      />
    </svg>
  );
}
